import React from 'react';
import styles from './terms-of-service.module.scss';
import { HeaderMenu } from '@/components/header-menu';
import { routesApp } from '@/constans/routes';
import { Typography } from '@/ui-kit';

const TermsOfService = () => {
    return (
        <>
            <HeaderMenu
                className={styles.headerMenu}
                headerBg="white"
                isFixed>
                <Typography
                    variant="p"
                    fontWeight="medium"
                    className={styles.header__title}
                    center
                >
                    Правила использования сервиса
                </Typography>
            </HeaderMenu>

            <div className={styles.content}>
                <h3>
                    <strong>1. Общие положения</strong>
                </h3>
                <div>
                    <ul>
                        <li>
                            <p>1.1. Сервис предназначен для поиска знакомств, дружбы и серьезных отношений.</p>
                        </li>
                        <li>
                            <p>1.2. Пользователь обязан соблюдать законодательство РФ и нормы морали.</p>
                        </li>
                        <li>
                            <p>
                                1.3. Администрация оставляет право блокировать аккаунты за нарушения без предупреждения.
                            </p>
                        </li>
                    </ul>
                </div>

                <h3>
                    <strong>2. Регистрация и профиль</strong>
                </h3>
                <p>2.1. Запрещено:</p>
                <ul>
                    <li>
                        <p>Использование чужих фото или данных.</p>
                    </li>
                    <li>
                        <p>Создание фейковых анкет.</p>
                    </li>
                    <li>
                        <p>Указание ложной информации (возраст, статус, цели).</p>
                    </li>
                    <li>
                        <p>2.2. Фото в профиле должны:</p>
                        <ul>
                            <li>
                                <p>Быть актуальными и четкими.</p>
                            </li>
                            <li>
                                <p>Показывать лицо (селфи, портреты).</p>
                            </li>
                            <li>
                                <p>
                                    <strong>Форматы</strong>: только <strong>JPG, PNG</strong> (HEIC можно загружать, но
                                    сервис автоматически конвертирует их в JPG).
                                </p>
                            </li>
                            <li>
                                <p>Запрещены: скриншоты, коллажи, мемы, анимированные GIF, эротика, реклама.</p>
                            </li>
                        </ul>
                    </li>
                </ul>

                <h3>
                    <strong>3. Общение и поведение</strong>
                </h3>
                <p>3.1. Запрещено:</p>
                <ul>
                    <li>
                        <p>Оскорбления, угрозы, домогательства.</p>
                    </li>
                    <li>
                        <p>Рассылка спама, рекламы, ссылок.</p>
                    </li>
                    <li>
                        <p>Попытки обмана (вымогательство, мошенничество).</p>
                    </li>
                    <li>
                        <p>3.2. Контент в чатах должен соответствовать нормам приличия.</p>
                    </li>
                </ul>

                <h3>
                    <strong>4. Безопасность</strong>
                </h3>

                <ul>
                    <li>
                        <p>4.1. Не передавайте личные данные (номер телефона, адрес) до уверенности в собеседнике.</p>
                    </li>
                    <li>
                        <p>4.2. Остерегайтесь мошенников, предлагающих деньги или инвестиции.</p>
                    </li>
                    <li>
                        <p>4.3. Фото и переписки нельзя распространять без согласия участников.</p>
                    </li>
                </ul>

                <h3>
                    <strong>5. Модерация и жалобы</strong>
                </h3>

                <ul>
                    <li>
                        <p>5.1. Администрация проверяет анкеты, но не гарантирует 100% безопасность.</p>
                    </li>
                    <li>
                        <p>5.2. Нарушители блокируются без возврата платежей (если есть подписка).</p>
                    </li>
                    <li>
                        <p>
                            5.3. Жалобы на пользователей можно отправить через кнопку <strong>"Пожаловаться"</strong>.
                        </p>
                    </li>
                </ul>

                <h3>
                    <strong>6. Технические требования</strong>
                </h3>

                <ul>
                    <li>
                        <p>
                            6.1. Оптимальный размер фото: <strong>от 500x500 пикселей, до 10 МБ</strong>.
                        </p>
                    </li>
                    <li>
                        <p>6.2. Автоматически удаляются:</p>
                        <ul>
                            <li>
                                <p>Размытые, нечитаемые изображения.</p>
                            </li>
                            <li>
                                <p>Фото с посторонними людьми без их согласия.</p>
                            </li>
                        </ul>
                    </li>
                </ul>

                <h3>
                    <strong>7. Заключительные положения</strong>
                </h3>

                <ul>
                    <li>
                        <p>
                            7.1. Администрация оставляет за собой право в одностороннем порядке изменять условия
                            настоящих Правил <strong>без предварительного уведомления пользователей</strong>. Новая
                            редакция Правил вступает в силу с момента их публикации в приложении/на сайте.
                        </p>
                        <p>
                            <strong>Рекомендуется периодически знакомиться с актуальной версией Правил.</strong>{' '}
                            Продолжение использования сервиса после внесения изменений означает согласие пользователя с
                            новой редакцией.
                        </p>
                    </li>
                    <li>
                        <p>
                            7.2. Используя сервис, вы соглашаетесь с обработкой данных в рамках Политики
                            конфиденциальности.
                        </p>
                    </li>
                </ul>

                <h3>
                    <strong>8. Конфиденциальность и защита информации</strong>
                </h3>

                <ol>
                    <li>Персональные данные Пользователя обрабатывается в соответствии с ФЗ «О персональных данных» № 152-ФЗ.</li>
                    <li>При регистрации на Сайте Пользователь предоставляет следующую информацию: Фамилия, Имя, Отчество, контактный номер телефона, адрес электронной почты, дату рождения, пол, адрес доставки товара.</li>
                    <li>Предоставляя свои персональные данные Сайту, Посетитель Сайта/Пользователь/Покупатель соглашается на их обработку Сайтом, в том числе в целях выполнения Сайтом обязательств перед Посетителем Сайта/Пользователем/Покупателем в рамках настоящей Публичной оферты , продвижения Сайтом товаров и услуг, проведения электронных и sms опросов, контроля результатов маркетинговых акций, клиентской поддержки, проведение розыгрышей призов среди Посетителей Сайта/Пользователей/ Покупателей, контроля удовлетворенности Посетителя Сайта/Пользователя/Покупателя, а также качества услуг, оказываемых Сайтом.</li>
                    <li>
                        <p>
                            Под обработкой персональных данных понимается любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение) извлечение, использование, передачу (в том числе передачу третьим лицам, не исключая трансграничную передачу, если необходимость в ней возникла в ходе исполнения обязательств), обезличивание, блокирование, удаление, уничтожение персональных данных.
                        </p>
                        <ol>
                            <li>
                                Продавец имеет право отправлять информационные, в том числе рекламные сообщения, на электронную почту и мобильный телефон Пользователя/Покупателя с его согласия, выраженного посредством совершения им действий, однозначно идентифицирующих этого абонента и позволяющих достоверно установить его волеизъявление на получение сообщения. Пользователь/Покупатель вправе отказаться от получения рекламной и другой информации без объяснения причин отказа путем информирования Сайта о своем отказе посредством направления соответствующего заявления на электронный адрес Сайта: <a href="http://travelask.ru/contact">здесь</a>.
                            </li>
                        </ol>
                    </li>
                    <li>Сайт вправе использовать технологию «cookies». «Cookies» не содержат конфиденциальную информацию. Посетитель / Пользователь / Покупатель настоящим дает согласие на сбор, анализ и использование cookies, в том числе третьими лицами для целей формирования статистики и оптимизации рекламных сообщений.</li>
                    <li>Сайт получает информацию об ip-адресе посетителя Сайта <a href="http://travelask.ru">euphora.travelask.ru</a>. Данная информация не используется для установления личности посетителя.</li>
                    <li>Сайт не несет ответственности за сведения, предоставленные Пользователем/Покупателем на Сайте в общедоступной форме.</li>
                    <li>
                        <a href="http://travelask.ru/terms">http://travelask.ru/terms</a>
                    </li>
                </ol>

                <h3>
                    <strong>9. Cookie-файлы</strong>
                </h3>

                <p>
                    <br />
                    9.1 Что такое cookie-файлы? GOOGLE определяет cookie-файл как «небольшой фрагмент текста, передаваемый в браузер с сайта, который вы посетили». Такие файлы не содержат конфиденциальных личных данных, таких как домашний адрес или данные платежной карты. Они помогают запомнить сайту информацию о ваших предпочтениях, например, языке, на котором вы его просматриваете, и позволяют сделать пользовательскую работу с сайтом более удобной.
                </p>
                <p>
                    9.2 Как мы используем cookie-файлы? Причины и виды cookie-файлов, которые мы используем:
                </p>
                
                <ul>
                    <li>
                        сессионные cookie-файлы – для корректной работы сайта;
                    </li>
                    <li>
                        cookie-файлы, которые запоминают регистрационную информацию - для сохранения Вашей информации в случае выбора опции «Запомнить меня» при регистрации или входе в учетную запись;
                    </li>
                    <li>
                        скрытые cookie-файлы по сбору статистики (количество посещений, интересующие разделы, время пребывания на сайте и т.д). Основная цель таких файлов – улучшение сайта, для того чтобы он максимально широкого отвечал запросам пользователей.
                    </li>
                    <li>
                        сторонние cookie-файлы - для предоставления рекламных материалов по другим веб-каналам.
                    </li>
                </ul>
                
                <p>
                    9.3 Безопасны ли cookie-файлы? Данные, которые хранятся в cookie-файлах анонимны и безопасны, так как не содержат личных идентификационных данных.
                </p>

                <p>
                    9.4 Можно ли отключить cookie-файлы? Пользователи могут отключить cookie-файлы, изменив соответствующие настройки в своем браузере. Пожалуйста, обратите внимание, что в случае отказа от cookie-файлов, работа с сайтом будет ограничена и многие функции сайта будут недоступны.
                </p>
            </div>
        </>
    );
};

export default TermsOfService;
